<template>
  <el-dialog title="转为失效达人" :visible.sync="dialogVisible" width="520px" :before-close="handleClose">
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="82px">
      <el-form-item label="原因" prop="selectId">
        <el-select v-model="form.selectId" filterable clearable placeholder='请选择原因'>
          <el-option v-for="(item, index) in invalidList" :key="index" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item prop="uneffect_reason" v-if="form.selectId === 0">
        <el-input type="textarea" :rows="2" placeholder="请输入原因" v-model="form.uneffect_reason" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { unEffectTalent } from '@/api/talentCRM'

export default {
  name: 'invalidDialog',
  data () {
    return {
      dialogVisible: false,
      invalidList: [
        { value: 1, label: '多次建联未通过' },
        { value: 2, label: '多次推品不回应' },
        { value: 3, label: '多次寄样不开播' },
        { value: 0, label: '其他（输入原因）' }
      ],
      anchor_id: '',
      form: {
        selectId: '',
        uneffect_reason: ''
      },
      rules: {
        selectId: { required: true, message: '请选择原因', trigger: 'change' },
        uneffect_reason: { required: true, message: '请输入原因', trigger: 'change' }
      }
    }
  },
  methods: {
    show(anchor_id) {
      this.anchor_id = anchor_id
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.anchor_id = ''
      this.form = {
        selectId: '',
        uneffect_reason: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if(!valid) return
        let { anchor_id, form: { selectId, uneffect_reason }, invalidList } = this
        uneffect_reason = selectId === 0 ? uneffect_reason : invalidList.find(item => item.value === selectId).label
        const { code } = await unEffectTalent({ anchor_id, uneffect_reason })
        if(code !== 0) return
        this.$message.success('转为失效达人成功')
        this.handleClose()
        this.$emit('getList')
      })
    }
  }
}
</script>

<style lang="less" scoped></style>
